/* it7 Round 3 - small global behaviours. Loaded site-wide by the it7-r3-loader
   section; every block self-guards so it no-ops on pages that lack the markup.
   - AI-037: prev/next arrows + swipe on the PDP main gallery image.
   - AI-039: shorten the (otherwise truncated) header search placeholder on phones. */
(function () {
  'use strict';

  /* localized UI strings injected by layout/theme.liquid (window.it7Strings); English fallback. */
  var IT7S = window.it7Strings || {};
  function S(k, fb) { var v = IT7S[k]; return (v != null && v !== '') ? v : fb; }

  /* AI-037 - PDP main image: arrows + swipe, cycling the existing thumb rail. */
  function gallery() {
    var gal = document.querySelector('.it7-pdp .main-im');
    var main = document.getElementById('it7-main-img');
    if (!gal || !main) return;
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('#it7-thumbs button'));
    if (thumbs.length < 2) return;            /* single image - nothing to navigate */
    if (gal.querySelector('.it7-gnav')) return; /* already wired */

    var i = 0;
    thumbs.forEach(function (t, idx) {
      if (t.classList.contains('on')) i = idx;
      t.addEventListener('click', function () { i = idx; }); /* keep index in sync with manual taps */
    });

    function go(n) {
      i = (n + thumbs.length) % thumbs.length;
      var t = thumbs[i];
      var src = t.getAttribute('data-src');
      if (src) main.src = src;
      thumbs.forEach(function (b) { b.classList.remove('on'); });
      t.classList.add('on');
      try { t.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' }); } catch (e) {}
    }

    function mk(cls, label, glyph) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'it7-gnav ' + cls;
      b.setAttribute('aria-label', label);
      b.textContent = glyph;
      return b;
    }
    var prev = mk('prev', S('prevImage','Previous image'), '‹');
    var next = mk('next', S('nextImage','Next image'), '›');
    prev.addEventListener('click', function (e) { e.preventDefault(); go(i - 1); });
    next.addEventListener('click', function (e) { e.preventDefault(); go(i + 1); });
    gal.appendChild(prev);
    gal.appendChild(next);

    var x0 = null;
    gal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    gal.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
      x0 = null;
    }, { passive: true });
  }

  /* AI-039 - the desktop placeholder is long and truncates on phones; swap to a
     short one at mobile widths. */
  function searchPlaceholder() {
    var sq = document.getElementById('it7-sq');
    if (sq && window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
      sq.setAttribute('placeholder', S('searchShort','Search 1,000+ designers…'));
    }
  }


  /* AI-019 (PLP badges) - place New (random up to 6 of the first 20 eligible) and
     Trending (4 across 3 of the first 4 rows) on the PLP/search grid. Early access is
     server-rendered on the card (customer + within 24h). Skips the New Arrivals
     collection pages. Runs once per grid (decorative; not re-applied on filter). */
  function plpBadges() {
    var grid = document.querySelector('.it7-pgrid');
    if (!grid || grid.dataset.it7badged) return;
    if (/\/collections\/new-arrivals/i.test(location.pathname)) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.pc'));
    if (!cards.length) return;
    grid.dataset.it7badged = '1';
    function shuffle(a) { a = a.slice(); for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
    /* one badge max per card. Early Access is server-rendered on the card already;
       the featured Editor's Pick (.hl) card is ineligible for any auto-badge. */
    function badged(c) { return c.classList.contains('hl') || !!c.querySelector('.it7-badge'); }
    function add(card, cls, label) {
      if (badged(card)) return;
      var im = card.querySelector('.im'); if (!im) return;
      var c = card.querySelector('.it7-badges');
      if (!c) { c = document.createElement('span'); c.className = 'it7-badges'; im.insertBefore(c, im.firstChild); }
      var s = document.createElement('span'); s.className = 'it7-badge ' + cls; s.textContent = label; c.appendChild(s);
    }
    /* Early Access AND New are both server-rendered on the card now (New is deterministic
       so PLP and PDP agree). This only places the decorative random TRENDING, on cards that
       aren't already badged -> still one badge max per card. */
    var gtc = getComputedStyle(grid).gridTemplateColumns;
    var cols = (gtc && gtc !== 'none') ? gtc.split(' ').filter(Boolean).length : 4;
    var rows = [];
    for (var r = 0; r < 4; r++) {
      var row = cards.slice(r * cols, (r + 1) * cols).filter(function (c) { return !badged(c); });
      if (row.length) rows.push(row);
    }
    var pool = [];
    shuffle(rows).slice(0, 3).forEach(function (r) { pool = pool.concat(r); });
    shuffle(pool).slice(0, 4).forEach(function (c) { add(c, 'it7-trending', S('trending','Trending')); });
  }

  /* "More Like This" — make "View all" the FINAL CARD in the carousel on ALL widths
     (Brett 2026-06-14, rev3). The standalone rail button is hidden (gated on
     .it7-mlt-hascard, so it stays as a fallback if JS doesn't run); a card-styled link
     is appended to the end of #it7-mlt-row, mirroring the button's search href (set by
     the MLT render script). The row populates lazily on scroll, so observe it. */
  function mltViewAll() {
    var sec = document.getElementById('it7-mlt');
    if (!sec) return;
    var row = document.getElementById('it7-mlt-row');
    var vab = sec.querySelector('[data-mlt-va]');
    if (!row || !vab) return;
    sec.classList.add('it7-mlt-hascard');
    var added = false;
    function addCard() {
      if (added || !row.children.length) return;
      added = true;
      var a = document.createElement('a');
      a.className = 'pc it7-mlt-vacard';
      a.href = vab.getAttribute('href') || '#';
      a.innerHTML = '<span class="vac">' + (vab.textContent || (S('viewAll','View all') + (document.documentElement.dir === 'rtl' ? ' ←' : ' →'))) + '</span>';
      row.appendChild(a);
    }
    if (row.children.length) addCard();
    else {
      var obs = new MutationObserver(function () { if (row.children.length) { addCard(); obs.disconnect(); } });
      obs.observe(row, { childList: true });
    }
  }

  /* Trust band rotation (Brett 2026-06-14): on phones the green trust strip shows one
     value prop at a time; cycle through them (CSS cross-fades via .it7-trust-on). */
  function trustRotate() {
    if (!(window.matchMedia && window.matchMedia('(max-width: 768px)').matches)) return;
    var wrap = document.querySelector('.it7-trust .it7-trust-in');
    if (!wrap) return;
    var items = wrap.children;
    if (items.length < 2) return;
    var i = 0;
    items[0].classList.add('it7-trust-on');
    setInterval(function () {
      items[i].classList.remove('it7-trust-on');                 /* fade the current one out (.5s) */
      var next = (i + 1) % items.length;
      setTimeout(function () { items[next].classList.add('it7-trust-on'); i = next; }, 540); /* then fade the next in — sequenced so the two lines never overlap */
    }, 2800);
  }

  /* AI-057 — sticky mobile Add-to-Bag bar. The long PDP scrolls the buy box off-screen;
     this fixed bottom bar (phones only) mirrors the main ATB's price + state and clicks it.
     (Mini-cart-on-add drawer is tracked separately — the base cart-drawer isn't wired to
     the it7 header, so it needs a dedicated integration pass.) */
  function pdpStickyAtb() {
    if (!(window.matchMedia && window.matchMedia('(max-width: 900px)').matches)) return;
    var atb = document.getElementById('it7-atb');
    var buy = atb && (atb.closest('.cta') || atb.closest('.buy'));
    if (!atb || !buy || document.querySelector('.it7-sticky-atb')) return;
    var bar = document.createElement('div');
    bar.className = 'it7-sticky-atb';
    bar.innerHTML = '<span class="sa-price"></span><button type="button" class="sa-btn">' + S('addToBag','Add to Bag') + '</button>';
    document.body.appendChild(bar);
    var saPrice = bar.querySelector('.sa-price'), saBtn = bar.querySelector('.sa-btn');
    function sync() {
      var txt = atb.textContent || '';
      saPrice.textContent = txt.indexOf('—') > -1 ? txt.split('—')[1].trim() : '';
      saBtn.disabled = atb.disabled && !atb.classList.contains('ok');
      if (atb.classList.contains('ok')) saBtn.textContent = S('addedToBag','Added to Bag') + ' ✓';
      else if (atb.classList.contains('err')) saBtn.textContent = S('tryAgain','Try again');
      else if (txt.indexOf('Adding') > -1 || txt.indexOf(S('adding','Adding…')) > -1) saBtn.textContent = S('adding','Adding…');
      else if (txt.indexOf('Sold') > -1 || txt.indexOf(S('soldOut','Sold out')) > -1) saBtn.textContent = S('soldOut','Sold out');
      else saBtn.textContent = S('addToBag','Add to Bag');
    }
    sync();
    new MutationObserver(sync).observe(atb, { childList: true, characterData: true, subtree: true, attributes: true });
    saBtn.addEventListener('click', function () { atb.click(); }); /* submits the form -> existing /cart/add flow */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { var on = !e.isIntersecting; bar.classList.toggle('show', on); document.body.classList.toggle('it7-atb-on', on); /* ITA2-903 */ }); }).observe(buy);
    } else { bar.classList.add('show'); document.body.classList.add('it7-atb-on'); }
  }

  /* AI-014 — restore the sticky "View results (N)" button in the mobile filter drawer
     (PLP + search). Injected once into .it7-sb; reads the live total from the grid's
     count element (#it7-total / #it7-count, updated by it7-plp-grid / it7-search-grid),
     and closes the drawer on tap. Hidden on desktop; pinned to the bottom of the open drawer. */
  function mobileFilterApply() {
    var sb = document.querySelector('.it7-sb');
    if (!sb || sb.querySelector('.it7-view-results')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'it7-view-results';
    function total() {
      var t = document.getElementById('it7-total');
      if (t && t.textContent.trim()) return t.textContent.trim();
      var c = document.getElementById('it7-count');
      if (c) { var m = c.textContent.match(/of\s*([\d,]+)/i); if (m) return m[1]; }
      return '';
    }
    function label() { var n = total(); btn.textContent = n ? (S('viewResults','View results') + ' (' + n + ')') : S('viewResults','View results'); }
    label();
    btn.addEventListener('click', function () { sb.classList.remove('open'); try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, 0); } });
    sb.appendChild(btn);
    var watch = document.getElementById('it7-total') || document.getElementById('it7-count');
    if (watch && window.MutationObserver) new MutationObserver(label).observe(watch, { childList: true, characterData: true, subtree: true });
    /* ITA2-908 — mirror the drawer's open state onto <body> so the promo/chat stack
       (Gorgias / Klaviyo) can be hidden while the drawer is open (it7-r3.css), keeping
       the sticky "View results" button tappable. Watching the class itself covers every
       close path: the X (data-fclose), this button, and a backdrop tap. */
    function syncOpen() { document.body.classList.toggle('it7-filter-open', sb.classList.contains('open')); }
    if (window.MutationObserver) new MutationObserver(syncOpen).observe(sb, { attributes: true, attributeFilter: ['class'] });
    syncOpen();
  }

  /* AI-057 — lightweight it7 mini-cart (add-confirmation). Opens whenever the cart count
     INCREASES (an add), via the it7:cart-updated event the PDP + sticky ATB already fire.
     Self-contained: fetches /cart.js, renders items + subtotal + Checkout/View-bag CTAs.
     (The base cart-drawer isn't wired to the it7 header, so we don't depend on it.) */
  function miniCart() {
    if (document.querySelector('.it7-mc')) return;
    var wrap = document.createElement('div');
    wrap.className = 'it7-mc';
    wrap.innerHTML =
      '<div class="it7-mc-ov"></div>' +
      '<aside class="it7-mc-panel" role="dialog" aria-label="' + S('bag','Bag') + '" aria-modal="true">' +
      '<div class="it7-mc-hd"><span class="it7-mc-ttl">' + S('addedToYourBag','Added to your bag') + '</span><button class="it7-mc-x" type="button" aria-label="' + S('close','Close') + '">×</button></div>' +
      '<div class="it7-mc-body"></div>' +
      '<div class="it7-mc-ft"><div class="it7-mc-sub"><span>' + S('subtotal','Subtotal') + '</span><span class="it7-mc-subv"></span></div>' +
      '<div class="it7-mc-cta"><a class="it7-mc-co" href="/checkout">' + S('checkout','Checkout') + '</a></div><a class="it7-mc-vb" href="' + (((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart') + '">' + S('viewBag','View bag') + '</a>' +
      '<button class="it7-mc-cont" type="button">' + S('continueShopping','Continue shopping') + '</button></div></aside>';
    /* .it7-mc-cta exists for Shipcheck: it mounts its cart block just before the checkout
       link's parent, so the wrapper lands it between Subtotal and Checkout. */
    document.body.appendChild(wrap);
    var body = wrap.querySelector('.it7-mc-body'), subv = wrap.querySelector('.it7-mc-subv');
    /* inert while closed: the panel stays visible for its .28s slide-out, but can't take focus or clicks */
    wrap.inert = true;
    function close() { wrap.classList.remove('open'); wrap.inert = true; document.body.classList.remove('it7-mc-lock'); }
    function open() { wrap.inert = false; wrap.classList.add('open'); document.body.classList.add('it7-mc-lock'); }
    wrap.querySelector('.it7-mc-ov').addEventListener('click', close);
    wrap.querySelector('.it7-mc-x').addEventListener('click', close);
    wrap.querySelector('.it7-mc-cont').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }
    function money(cents) { return (window.IT7FX && IT7FX.format) ? IT7FX.format(cents / 100) : ('$' + Math.round(cents / 100).toLocaleString('en-US')); }
    function render(c) {
      body.innerHTML = (c.items || []).map(function (it) {
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
        var opt = (it.options_with_values || []).map(function (o) { var v = o.value; return /^(tu|os|osfa|uni|unica|unique|onesize|one ?size|onesizefitsall|taglia ?unica)$/i.test(String(v).trim()) ? S('oneSize','One size') : v; }).filter(function (v) { return v && v !== 'Default Title'; }).join(' / ');
        return '<div class="it7-mc-it"><a href="' + esc(it.url) + '" class="it7-mc-im">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="it7-mc-meta"><div class="it7-mc-b">' + esc(it.vendor || '') + '</div>' +
          '<a href="' + esc(it.url) + '" class="it7-mc-n">' + esc(it.product_title || it.title) + '</a>' +
          (opt ? '<div class="it7-mc-opt">' + esc(opt) + '</div>' : '') +
          '<div class="it7-mc-pr">' + money(it.final_line_price) + '</div></div></div>';
      }).join('');
      subv.textContent = money(c.total_price);
    }
    var last = null;
    document.addEventListener('it7:cart-updated', function () {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        render(c);
        if (last !== null && c.item_count > last) open();   /* open only on an ADD */
        last = c.item_count;
      }).catch(function () {});
    });
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { if (last === null) last = c.item_count; }).catch(function () {});
  }

  /* AI-056 (cart) — normalize raw one-size codes ("TU"/"ONESIZE"/"OS"/…) to "One size" on
     the cart-page line items (the base main-cart section renders the variant title raw).
     Best-effort selectors; only replaces leaf elements whose exact text is a size code. */
  function normalizeCartSizes() {
    if (!/template-cart/.test(document.body.className) && location.pathname.indexOf('/cart') !== 0) return;
    var RX = /^(tu|os|osfa|uni|unica|unique|onesize|one ?size|onesizefitsall|taglia ?unica)$/i;
    document.querySelectorAll('[class*="cart-item"] dd, [class*="cart-item"] [class*="option"], cart-items dd, .cart-items dd, [class*="line-item"] dd, [class*="product-option"], [class*="variant"]').forEach(function (el) {
      if (el.children.length === 0 && RX.test((el.textContent || '').trim())) el.textContent = S('oneSize','One size');
    });
  }

  /* AI-060 — quick-add from PLP/search grid cards. A hover-revealed "Add to bag" on each
     #it7-grid card: one-size products add directly; multi-size reveal available-size pills.
     Variant data comes from /products/{handle}.js (same source hydrate() uses). On add it
     fires it7:cart-updated so the bespoke mini-cart opens. Desktop hover only — on touch the
     card stays a clean tap-through to the PDP (set via CSS @media (hover:none)). */
  function quickAdd() {
    /* ITA2-1115: quick-add also runs on the cart rails (same-shop + finishing
       touches) — same .pc cards, same embedded data-it7-qa variants. */
    /* + creator "shop the look" rows (#it7-looks) — same cards, same embedded
       data-it7-qa, so looks get the identical hover size-pills / add-to-bag. */
    var roots = ['it7-grid', 'cart-same-shop-page', 'cart-cross-sell-page', 'it7-looks']
      .map(function (id) { return document.getElementById(id); })
      .filter(Boolean);
    if (!roots.length) return;
    var ONE = /^(tu|os|osfa|uni|unica|unique|onesize|one ?size|onesizefitsall|taglia ?unica|default title)$/i;
    var cache = {};
    function qesc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }
    /* Sort size pills smallest -> largest. Handles letter sizes (XXS..XXXXL), numeric
       (36, 36.5, 42), and shoe formats ("EU40/US10" -> ranks on the first number).
       Groups: letters before numbers before anything else; alpha as a last resort. */
    var SZ = { XXXS: -4, XXS: -3, XS: -2, S: -1, M: 0, L: 1, XL: 2, XXL: 3, XXXL: 4, XXXXL: 5 };
    function sizeRank(title) {
      var t = String(title == null ? '' : title).trim().toUpperCase().replace(/\s+/g, '');
      if (SZ.hasOwnProperty(t)) return [0, SZ[t], ''];
      var m = t.match(/\d+(?:[.,]\d+)?/);
      if (m) return [1, parseFloat(m[0].replace(',', '.')) + (/^\d+\+$/.test(t) ? 0.5 : 0), '']; /* ITA2-1348: N+ sits between N and N+1 */
      return [2, 0, t];
    }
    function bySize(a, b) {
      var ra = sizeRank(a.title), rb = sizeRank(b.title);
      if (ra[0] !== rb[0]) return ra[0] - rb[0];
      if (ra[0] === 2) return ra[2] < rb[2] ? -1 : (ra[2] > rb[2] ? 1 : 0);
      return ra[1] - rb[1];
    }
    function handleOf(card) {
      if (card.dataset.handle) return card.dataset.handle;
      var a = card.querySelector('a.im[href*="/products/"], a[href*="/products/"]');
      return a ? ((a.getAttribute('href') || '').split('?')[0].split('/products/')[1] || '') : '';
    }
    function isOneSize(vs) {
      /* "one size" = NO real size choice (sunglasses/bags), not merely a single variant.
         A shoe made in one size must still reveal that size pill on hover, never "Add to bag". */
      if (!vs || !vs.length) return true;
      return vs.every(function (v) { return ONE.test(String(v.title || '').trim()); });
    }
    function decorate(card) {
      if (card.querySelector('.it7-qa') || card.querySelector('.it7-qa-sizes')) return;
      var im = card.querySelector('.im');
      if (!im || !handleOf(card)) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'it7-qa';
      b.textContent = S('addToBagLc','Add to bag');
      im.appendChild(b);
    }
    /* ITA2-897 — reveal sizes for MULTI-SIZE (clothing) products on hover with NO latency.
       The SSR card embeds its variants in data-it7-qa, so hovering classifies + renders the
       size pills SYNCHRONOUSLY (no /products.js round-trip → no "Add to bag" flash, and every
       card behaves the same). ONE-SIZE products (bags/accessories) keep the direct Add-to-bag
       button. JS-built cards (filtered/search grids) have no attr and fall back to fetch.
       Desktop hover only — touch hides the control via CSS @media (hover:none). */
    function embedded(card) {
      var raw = card.getAttribute('data-it7-qa');
      if (!raw) return null;
      try {
        var arr = JSON.parse(raw);
        if (!arr || !arr.length) return null;
        return arr.map(function (v) { return { id: v.id, title: v.t, available: v.a }; });
      } catch (e) { return null; }
    }
    function revealSizes(card, vs) {
      if (isOneSize(vs)) return;                 /* one-size → keep the Add-to-bag button */
      var qb = card.querySelector('.it7-qa');
      if (qb && !qb.disabled && !qb.classList.contains('done')) openSizes(card, qb, vs, true);
    }
    function primeHover(card) {
      if (card.dataset.qaHover) return;
      card.dataset.qaHover = '1';
      card.addEventListener('mouseenter', function () {
        var vs = embedded(card);
        if (vs) { revealSizes(card, vs); return; }   /* instant — no fetch, no flash */
        var handle = handleOf(card);                  /* fallback: JS-built cards w/o embedded data (pre-hydrate hover) */
        if (!handle) return;
        var qb = card.querySelector('.it7-qa');       /* show "Loading sizes…" instead of a stale "Add to bag" while we fetch */
        if (qb && !qb.classList.contains('done')) qb.textContent = 'Loading sizes…';
        getProduct(handle).then(function (p) {
          var pv = p.variants || [];
          if (qb && !qb.classList.contains('done') && isOneSize(pv)) qb.textContent = 'Add to bag'; /* one-size keeps the button — restore its label */
          revealSizes(card, pv);
        }).catch(function () { if (qb) qb.textContent = 'Add to bag'; });
      });
    }
    function scan() { roots.forEach(function (root) { root.querySelectorAll('.pc').forEach(function (card) { decorate(card); primeHover(card); }); }); }
    scan();
    roots.forEach(function (root) { new MutationObserver(scan).observe(root, { childList: true, subtree: true }); });
    function getProduct(handle) {
      if (!cache[handle]) cache[handle] = fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'products/' + handle + '.js').then(function (r) { return r.json(); });
      return cache[handle];
    }
    function add(variantId, card, anchor) {
      anchor.textContent = S('adding','Adding…');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function () {
          /* ITA2-1115: on the cart PAGE a drawer over a stale list is wrong — reload so
             the line items, totals and (when live) the bundle-discount row all update. */
          if (document.body.classList.contains('body-template-cart')) { location.reload(); return; }
          document.dispatchEvent(new CustomEvent('it7:cart-updated'));
          var sizes = card.querySelector('.it7-qa-sizes');
          if (sizes) sizes.remove();
          var qb = card.querySelector('.it7-qa');
          if (!qb) { decorate(card); qb = card.querySelector('.it7-qa'); }
          if (qb) { qb.classList.add('done'); qb.textContent = S('added','Added') + ' ✓'; setTimeout(function () { if (qb.isConnected) { qb.classList.remove('done'); qb.textContent = S('addToBagLc','Add to bag'); } }, 2200); }
        })
        .catch(function () { anchor.textContent = S('tryAgain','Try again'); });
    }
    /* ITA2-1348: on FOOTWEAR, "N+" is the vendors' half-size notation - the quick-add
       pills show it as N.5 (PDP parity). Category comes from data-it7-type (SSR card /
       grid hydrate); non-footwear (kids apparel age bands like "12+") and cards without
       the attr (pre-deploy CDN cache) keep the raw value. Variant id is untouched. */
    var FOOTWORDS = { sneaker:1, sneakers:1, boot:1, boots:1, bootie:1, booties:1, sandal:1, sandals:1, pump:1, pumps:1, loafer:1, loafers:1, espadrille:1, espadrilles:1, heel:1, heels:1, mule:1, mules:1, moccasin:1, moccasins:1, brogue:1, brogues:1, derby:1, derbies:1, oxford:1, oxfords:1, ballerina:1, ballerinas:1, ballet:1, flat:1, flats:1, slipper:1, slippers:1, clog:1, clogs:1, wedge:1, wedges:1, shoe:1, shoes:1, trainer:1, trainers:1 };
    function isFootwearCard(card) {
      var ty = String((card && card.getAttribute('data-it7-type')) || '').trim().toLowerCase();
      if (!ty) return false;
      var ws = ty.split(/\s+/);
      return FOOTWORDS[ws[ws.length - 1]] === 1;
    }
    function openSizes(card, btn, variants, fromHover) {
      var avail = variants.filter(function (v) { return v.available; });
      if (!avail.length) {
        if (fromHover) return;                 /* ITA2-897: never mutate the card on hover */
        btn.disabled = true; btn.classList.add('soldout'); btn.textContent = S('soldOut','Sold out'); return;
      }
      /* click on a ONE-SIZE product → add straight away (one available size, or several
         that are all one-size tokens e.g. a 2-colour "One Size" bag — never render two
         indistinguishable "One size" pills). On HOVER never auto-add. */
      if (!fromHover && (avail.length === 1 || avail.every(function (v) { return ONE.test(String(v.title || '').trim()); }))) {
        add(avail[0].id, card, btn); return;
      }
      avail.sort(bySize); /* smallest -> largest, regardless of variant order in the feed */
      var foot = isFootwearCard(card);
      var im = card.querySelector('.im');
      var wrap = document.createElement('div');
      wrap.className = 'it7-qa-sizes';
      wrap.innerHTML = avail.map(function (v) {
        var vt = String(v.title || '').trim();
        var label = ONE.test(vt) ? S('oneSize','One size') : ((foot && /^\d+\+$/.test(vt)) ? (parseInt(vt, 10) + 0.5) : v.title);
        return '<button type="button" class="it7-qa-sz" data-vid="' + v.id + '">' + qesc(label) + '</button>';
      }).join('');
      btn.remove();
      im.appendChild(wrap);
    }
    function onClick(e) {
      var sz = e.target.closest('.it7-qa-sz');
      if (sz) { e.preventDefault(); e.stopPropagation(); add(parseInt(sz.dataset.vid, 10), sz.closest('.pc'), sz); return; }
      var qb = e.target.closest('.it7-qa');
      if (!qb || qb.disabled || qb.classList.contains('done')) return;
      e.preventDefault(); e.stopPropagation();
      var card = qb.closest('.pc');
      var vs = embedded(card);
      if (vs) { openSizes(card, qb, vs); return; }   /* instant: one-size adds, multi reveals pills — no fetch */
      var handle = handleOf(card);                    /* fallback: JS-built cards w/o embedded data */
      if (!handle) return;
      qb.textContent = S('loading','Loading…');
      getProduct(handle).then(function (p) { qb.textContent = S('addToBagLc','Add to bag'); openSizes(card, qb, p.variants || []); })
        .catch(function () { qb.textContent = S('tryAgain','Try again'); });
    }
    roots.forEach(function (root) { root.addEventListener('click', onClick); });
  }

  /* ITA2-1115 — cart page: reveal the server-rendered mobile sticky "Proceed to checkout"
     bar (.it7-cart-sticky) only while the real footer button is scrolled off-screen, so the
     CTA is reachable from the top (below the fold with 2+ items) without duplicating a second
     button on screen once you reach the real one. Phones only; no-ops where the bar is absent.
     The bar's button is a real form="cart" name="checkout" submit — this just toggles .show. */
  function stickyCartCheckout() {
    var bar = document.querySelector('.it7-cart-sticky');
    if (!bar) return;                                                     /* not the cart page */
    if (!(window.matchMedia && window.matchMedia('(max-width: 900px)').matches)) return;
    /* Observe the stable #main-cart-footer, not .cart__checkout-button: the button lives
       inside .js-contents-2, whose innerHTML is swapped on every AJAX cart update, which
       would detach an observer bound to it. #main-cart-footer survives re-renders. */
    /* measurement probe: how many mobile checkouts start from this bar (vs the real
       button) — GA4 event, compared against mobile begin_checkout. Fires before the
       native form submit; gtag is a queue push, so it never delays navigation. */
    function ga(protection) {
      try {
        window.dataLayer = window.dataLayer || [];
        window.gtag = window.gtag || function () { dataLayer.push(arguments); };
        window.gtag('event', 'sticky_checkout_click', { protection: protection });
      } catch (e) {}
    }
    var btn = bar.querySelector('.it7-cs-btn');
    if (btn) btn.addEventListener('click', function (e) {
      var rail = bar.classList.contains('it7-cs-rail');
      if (rail && locked()) { e.preventDefault(); return; }
      if (rail) busy();                          /* no protection tap can race this submit */
      ga(rail ? 'no' : 'not_offered');
    });

    /* Shipcheck "Checkout button" layout: the bar offers the same pair as the page,
       [ CHECKOUT ][ WITH PROTECTION +price ], and a protection tap clicks Shipcheck's own button
       (it adds the protection line and goes to checkout itself). Only while Shipcheck's button and
       price are on the page — otherwise, or on any error, the bar stays the plain-checkout bar. */
    var pro = bar.querySelector('.it7-cs-pro');
    function shipcheck() {   /* fresh lookup: cart.js swaps the footer on every update and Shipcheck re-mounts */
      var w = document.querySelector('.cart__blocks-content shipcheck-cart-widget');
      var b = w && w.querySelector('button[class^="asc-checkout-button-"]');
      var p = w && w.querySelector('p.asc-shipping-protection-price');
      var price = p ? p.textContent.trim() : '';
      return b && b.offsetParent && price ? { btn: b, price: price } : null;   /* missing, hidden or toggle layout */
    }
    function setH() { document.body.style.setProperty('--it7-cs-h', bar.offsetHeight + 'px'); }
    function sync() {
      try {
        var s = pro && shipcheck();
        var price = pro && pro.querySelector('.it7-cs-price');
        if (s && price.textContent !== '+' + s.price) price.textContent = '+' + s.price;   /* only on change: no self-triggered mutations */
        if (pro) pro.hidden = !s;
        bar.classList.toggle('it7-cs-rail', !!s);
      } catch (e) { bar.classList.remove('it7-cs-rail'); if (pro) pro.hidden = true; }
      setH();
    }
    function locked() { return /\bit7-cs-(busy|loading|wait)\b/.test(bar.className); }
    function busy() { bar.classList.add('it7-cs-busy'); setTimeout(function () { bar.classList.remove('it7-cs-busy'); }, 10000); }  /* safety if nothing navigates */
    if (pro) pro.addEventListener('click', function () {
      if (locked()) return;
      var s = shipcheck();
      if (!s || pro.querySelector('.it7-cs-price').textContent !== '+' + s.price) return sync();   /* changed since drawn: redraw, let them tap again */
      busy(); ga('yes');
      s.btn.click();
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) { bar.classList.remove('it7-cs-busy', 'it7-cs-wait'); sync(); } });
    /* After a cart update Shipcheck re-reads /cart.js and may switch price tier (9.99 -> 14.99 over $1,999).
       Hold both choices until that read has landed, so a quick tap can't add the old tier; capped at 2.5s. */
    var waitT = 0, po = null;
    function release() { clearTimeout(waitT); if (po) { po.disconnect(); po = null; } sync(); bar.classList.remove('it7-cs-wait'); onScroll(); }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      bar.classList.add('it7-cs-wait');
      var t0 = performance.now();
      clearTimeout(waitT); waitT = setTimeout(release, 2500);
      if (po) po.disconnect();
      try {
        po = new PerformanceObserver(function (list) {
          if (list.getEntries().some(function (en) { return /\/cart\.js(\?|$)/.test(en.name) && en.startTime > t0; })) {
            po.disconnect(); po = null; requestAnimationFrame(function () { requestAnimationFrame(release); });
          }
        });
        po.observe({ type: 'resource' });
      } catch (e) {}
    });
    /* Shipcheck mounts after us and re-mounts after each update; cart updates also move the page buttons */
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; if (!bar.classList.contains('it7-cs-wait')) sync(); onScroll(); });
    }).observe(document.getElementById('main-cart-footer') || document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['style', 'hidden'] });   /* Shipcheck hides its block with an inline style */
    if (window.ResizeObserver) new ResizeObserver(setH).observe(bar);
    sync();
    /* Show the bar while the real "Proceed to checkout" button is off-screen.
       Chrome on iOS shows/hides its address bar as you scroll, which resizes the
       layout viewport every frame — an IntersectionObserver (or a bare rect test)
       toggles on/off with it and FLICKERS (Safari, with a stable viewport, didn't).
       Fix = HYSTERESIS: two thresholds with a dead zone between them. Show only when
       the button is comfortably below the fold; hide only when it's comfortably in
       view; in the gap, hold the current state. A ~50px toolbar swing can't cross
       both lines, so it can't flip the bar. rAF-throttled; also listens to
       visualViewport resize so the toolbar animation itself settles cleanly. */
    var shown = false, ticking = false;
    var SHOW_GAP = 24;   /* button top must be this far below the fold to SHOW */
    var HIDE_GAP = 96;   /* button bottom must be this far inside the fold to HIDE */
    function evaluate() {
      ticking = false;
      if (!bar.isConnected) { document.body.classList.remove('it7-cartbar-on'); return; }   /* cart.js drops the bar when the cart empties */
      /* looked up every time: cart.js re-renders the button on each update, and a stale node reads 0,0 forever */
      var real = document.querySelector('.cart__checkout-button');
      var next = true;                                              /* no real button: keep the bar up */
      if (real) {
        var vh = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
        var r = real.getBoundingClientRect();
        next = shown;
        if (r.top > vh - SHOW_GAP || r.bottom < 0) next = true;   /* button below the fold (or scrolled well above) */
        else if (r.bottom < vh - HIDE_GAP && r.top > 0) next = false; /* button sitting clearly in view */
      }
      if (next !== shown) {
        shown = next;
        bar.classList.toggle('show', shown);
        document.body.classList.toggle('it7-cartbar-on', shown);  /* lifts the Gorgias bubble clear of the bar */
      }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(evaluate); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    if (window.visualViewport) window.visualViewport.addEventListener('resize', onScroll, { passive: true });
    evaluate();
  }

  /* Shipcheck draws its own "checkout with protection" button, so global.js never gives it the
     theme's letter-roll hover. Build the same markup wrapLetters() builds (desktop only, like the
     theme), re-apply whenever Shipcheck re-mounts, and leave the button alone while Shipcheck shows
     its spinner (it restores the saved content afterwards). */
  function shipcheckHover() {
    if (window.innerWidth < 1200) return;
    function copy(text, n) {
      var anim = document.createElement('span'), w = document.createElement('span');
      anim.className = 'animation is-' + n; w.className = 'wrapper';
      Array.from(text).forEach(function (ch, i) {
        var c = document.createElement('span');
        c.className = 'char'; c.textContent = ch; c.style.setProperty('--char-index', i + 1);
        w.appendChild(c);
      });
      anim.appendChild(w);
      return anim;
    }
    function wrap(btn) {
      if (btn.hasAttribute('data-asc-loading') || btn.querySelector('.animation-wrapper')) return;
      var label = btn.querySelector('span'), text = label && label.textContent.trim();
      if (!text) return;
      var aw = document.createElement('span');
      aw.className = 'animation-wrapper';
      aw.setAttribute('aria-hidden', 'true');           /* letters + second copy are visual only */
      aw.setAttribute('dir', 'auto');                   /* letters are inline-blocks: keep the label's own order on RTL pages */
      btn.setAttribute('aria-label', text);
      aw.appendChild(copy(text, 1)); aw.appendChild(copy(text, 2));
      label.textContent = ''; label.appendChild(aw);
      btn.classList.add('it7-sc-anim');
    }
    var queued = false;
    function scan() {
      queued = false;
      document.querySelectorAll('shipcheck-cart-widget button[class^="asc-checkout-button-"]').forEach(wrap);
    }
    new MutationObserver(function () { if (!queued) { queued = true; requestAnimationFrame(scan); } })
      .observe(document.body, { childList: true, subtree: true });
    scan();
  }

  function init() { gallery(); searchPlaceholder(); plpBadges(); mltViewAll(); trustRotate(); pdpStickyAtb(); mobileFilterApply(); miniCart(); normalizeCartSizes(); quickAdd(); stickyCartCheckout(); shipcheckHover(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

